import styled from '@emotion/styled';

export const TitleGroup = styled.div({
    display: 'flex',
    flexDirection: 'column',
});

export const Title = styled.h2(({ theme }) => ({
    ...theme.typography.headline.h3.medium,
    color: theme.colors.black[900],
    fontSize: '1.5rem',
    letterSpacing: '-0.02em',
    margin: 0,
}));

export const Description = styled.p(({ theme }) => ({
    ...theme.typography.body.S.regular,
    color: theme.colors.black[500],
    lineHeight: 1.6,
    margin: 0,
    marginTop: theme.spacing.xs,
}));

export const Container = styled.div(({ theme }) => ({
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '100%',
    paddingLeft: theme.spacing['8xl'],
    paddingRight: theme.spacing['8xl'],
    paddingTop: `calc(${theme.spacing['3xl']} + ${theme.spacing.m})`,
}));

export const WidthLimiter = styled.div(() => ({ maxWidth: '32rem' }));

export const Footer = styled.div(({ theme }) => ({
    backgroundColor: theme.colors.white[200],
    borderTop: `1px solid ${theme.colors.gray[300]}`,
    bottom: 0,
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'space-between',
    marginTop: theme.spacing.xxl,
    paddingBottom: theme.spacing['4xl'],
    paddingTop: theme.spacing['3xl'],
    position: 'sticky',
    width: '100%',
    zIndex: 10,
}));

export const FooterActions = styled.div({
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
});

export const ButtonGroup = styled.div(({ theme }) => ({
    display: 'flex',
    gap: theme.spacing.m,
}));

export const FormContainer = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing['4xl'],
    marginTop: theme.spacing['8xl'],
    maxWidth: 640,
}));

export const FormField = styled.div({
    display: 'flex',
    flexDirection: 'column',
});

export const Label = styled.label(({ theme }) => ({
    ...theme.typography.body.S.medium,
    color: theme.colors.black[900],
    display: 'block',
    letterSpacing: '-0.01em',
    marginBottom: theme.spacing.m,
}));

export const RequiredMark = styled.span(({ theme }) => ({
    color: theme.colors.error[500],
}));

export const ErrorMessage = styled.span(({ theme }) => ({
    ...theme.typography.body.S.regular,
    color: theme.colors.error[700],
}));

export const InfoBanner = styled.div(({ theme }) => ({
    alignItems: 'flex-start',
    backgroundColor: theme.colors.warning[50],
    border: `1px solid ${theme.colors.warning[200]}`,
    borderRadius: theme.borderRadius.l,
    display: 'flex',
    gap: theme.spacing.xl,
    marginBottom: theme.spacing['4xl'],
    padding: `${theme.spacing.xl} ${theme.spacing['3xl']}`,
}));

export const InfoBannerContent = styled.div({
    flex: 1,
});

export const InfoBannerTitle = styled.p(({ theme }) => ({
    ...theme.typography.body.S.semibold,
    color: theme.colors.warning[900],
    letterSpacing: '-0.01em',
    margin: 0,
}));

export const InfoBannerDescription = styled.p(({ theme }) => ({
    ...theme.typography.body.XS.regular,
    color: theme.colors.warning[800],
    margin: 0,
    marginTop: theme.spacing.xs,
}));
